import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=7aed7374&scoped=true&lang=pug&"
import script from "./BlogPage.vue?vue&type=script&lang=js&"
export * from "./BlogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed7374",
  null
  
)

export default component.exports